import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';

import deleteSchematicsDialog from './dialog.deleteSchematicsDialog';
import controller from './schematics.controller';
import directive from './schematics.directive';
import schematicSection from './schematicSection';


export default angular.module('app.components.advisory.bcp.schematics', [
  bcpDataService,
  constants,
  schematicSection,
  ssDialogService,
  deleteSchematicsDialog,
])
  .directive('bcpSchematics', directive)
  .controller('SchematicsController', controller)
  .name;

console.log('app.components.advisory.bcp.schematics created');
